// extracted by mini-css-extract-plugin
export default {"sf_nav":"SpecialtyFaq_sf_nav__cB0V4","sf_header":"SpecialtyFaq_sf_header__kxf6R","sf_cont":"SpecialtyFaq_sf_cont__i2+Z2"};